/**
 * @generated SignedSource<<7e697bf5ffcfdce5e256c72bd6993ee7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternReadyToSubmitCardMutation$variables = {
  brandId: string;
  pipelineId: string;
  platform: string;
};
export type InternReadyToSubmitCardMutation$data = {
  readonly submitForReview: {
    readonly message: string;
    readonly success: boolean;
  };
};
export type InternReadyToSubmitCardMutation = {
  response: InternReadyToSubmitCardMutation$data;
  variables: InternReadyToSubmitCardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pipelineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "platform"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      },
      {
        "kind": "Variable",
        "name": "pipelineId",
        "variableName": "pipelineId"
      },
      {
        "kind": "Variable",
        "name": "platform",
        "variableName": "platform"
      }
    ],
    "concreteType": "SubmitForReviewPayload",
    "kind": "LinkedField",
    "name": "submitForReview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternReadyToSubmitCardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternReadyToSubmitCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3be7d3f35132e1483cbd3ae1e9fab095",
    "id": null,
    "metadata": {},
    "name": "InternReadyToSubmitCardMutation",
    "operationKind": "mutation",
    "text": "mutation InternReadyToSubmitCardMutation(\n  $brandId: ID!\n  $pipelineId: ID!\n  $platform: String!\n) {\n  submitForReview(brandId: $brandId, pipelineId: $pipelineId, platform: $platform) {\n    success\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "c72451bb59134f8c8a25a1127c6d38ff";

export default node;
